module.exports = __webpack_public_path__ + "img/comp-tronlong.f6436d94.svg";